import { Component, Input, OnInit } from '@angular/core';
import { CupraBudgetModel } from '../../../models/cuprabudget';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'budget-summary',
  templateUrl: './budget-summary.component.html',
  styleUrls: ['./budget-summary.component.scss']
})

export class BudgetSummaryComponent implements OnInit {

  @Input() model: CupraBudgetModel;

  pathServer = environment.urlServer;

  constructor() { }

  ngOnInit() {
    this.model.BudgetPrice = 0;
    this.setExistingBudget();
  }

  setExistingBudget() {
    const that = this;

    this.model.BudgetOperations = this.model.BudgetOperations.sort(function (x, y) {
      let a = x.OperationCode.toUpperCase(),
        b = y.OperationCode.toUpperCase();
      return a == b ? 0 : a > b ? 1 : -1;
    });

    this.model.BudgetOperations.forEach(elem => {
      that.model.BudgetPrice += elem.FinalPrice;
    });

    this.model.BudgetPiezaDesgaste.forEach(elem => {
      that.model.BudgetPrice += elem.FinalPrice;
    });
  }

}
